import { cn } from "@/lib/utils";

const STATUS_STYLES = {
  // candidate statuses
  READY_TO_SEND: "bg-emerald-50 text-emerald-700 border-emerald-200",
  SENT_TO_EC: "bg-emerald-50 text-emerald-700 border-emerald-200",
  CONFIRMED_IN_BILLS: "bg-emerald-50 text-emerald-700 border-emerald-200",
  SENDING_TO_EC: "bg-blue-50 text-blue-700 border-blue-200",
  SEND_FAILED: "bg-red-50 text-red-700 border-red-200",
  // legacy aliases (older records)
  READY_TO_CONFIRM: "bg-emerald-50 text-emerald-700 border-emerald-200",
  CONFIRMED_LINKED: "bg-emerald-50 text-emerald-700 border-emerald-200",
  CONFIRMING: "bg-blue-50 text-blue-700 border-blue-200",
  NEEDS_REVIEW: "bg-amber-50 text-amber-800 border-amber-200",
  UPLOADED: "bg-slate-100 text-slate-700 border-slate-200",
  OCR_PROCESSING: "bg-blue-50 text-blue-700 border-blue-200",
  BLOCKED: "bg-red-50 text-red-700 border-red-200",
  OCR_FAILED: "bg-red-50 text-red-700 border-red-200",
  REJECTED: "bg-stone-100 text-stone-600 border-stone-200",
  // duplicate / recon
  HARD_DUPLICATE: "bg-red-50 text-red-700 border-red-200",
  POSSIBLE_DUPLICATE: "bg-amber-50 text-amber-800 border-amber-200",
  NO_DUPLICATE: "bg-stone-100 text-stone-600 border-stone-200",
  EXACT_MATCH: "bg-emerald-50 text-emerald-700 border-emerald-200",
  MISMATCH: "bg-red-50 text-red-700 border-red-200",
  MINOR_VARIANCE: "bg-amber-50 text-amber-800 border-amber-200",
};

const LABELS = {
  READY_TO_SEND: "Ready to confirm",
  SENT_TO_EC: "Sent to Expense Capture — historical",
  CONFIRMED_IN_BILLS: "Confirmed in 1OS Bills",
  SENDING_TO_EC: "Legacy handoff — historical",
  SEND_FAILED: "Legacy handoff failed — historical",
  // legacy
  READY_TO_CONFIRM: "Ready to confirm",
  CONFIRMED_LINKED: "Sent to Expense Capture — historical",
  CONFIRMING: "Legacy handoff — historical",
  NEEDS_REVIEW: "Needs Review",
  UPLOADED: "Uploaded",
  OCR_PROCESSING: "OCR…",
  BLOCKED: "Blocked",
  OCR_FAILED: "OCR Failed",
  REJECTED: "Rejected",
  HARD_DUPLICATE: "Duplicate",
  POSSIBLE_DUPLICATE: "Duplicate?",
  NO_DUPLICATE: "Unique",
  EXACT_MATCH: "Totals Match",
  MISMATCH: "Totals Mismatch",
  MINOR_VARIANCE: "Variance",
};

export default function StatusChip({ status, label, className, testId }) {
  const cls = STATUS_STYLES[status] || "bg-stone-100 text-stone-600 border-stone-200";
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center justify-center px-2 py-0.5 rounded-full border text-[11px] font-semibold uppercase tracking-wider whitespace-nowrap",
        cls,
        className
      )}
    >
      {label || LABELS[status] || status}
    </span>
  );
}

export function OriginChip({ origin, className }) {
  if (!origin) return null;
  return (
    <span
      className={cn(
        "inline-flex items-center justify-center px-1.5 py-0.5 rounded border bg-archival-soft border-archival text-archival-secondary text-[10px] font-medium tracking-wide",
        className
      )}
    >
      {String(origin).toUpperCase()}
    </span>
  );
}
